import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React from 'react'
import { toast } from 'react-toastify'
import Button from '../../../components/Button'
import Text from '../../../components/Text'

interface Props {

}

const ActivateScreen: React.FC<Props> = () => {
  const { token, user } = useAuth()

  return (
    <div>
      <Text
        tag="h1"
      >
        Ativação da conta
      </Text>
      <Text tag="p">Por gentileza, verifique seu e-mail para continuar o processo de registro de imovel.</Text>
      <Button
        label="Reenviar e-mail"
        onClick={(evt: any) => {
          Axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/email/resend/${user.id}`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }).then(({ data }) => {
            toast.success(data.message)
          }).catch(() => {
            toast.error('Ocorreu um erro, verifique sua conexão com a Internet')
          })
        }}
      >
      </Button>

    </div>
  )
}

export default ActivateScreen
